export class SecurityUserGroupDto {
  SecurityUserGroupId: string | null;
  UserOrUserGroupId: string;
  IsReadOnlySelected: boolean;
  IsNewSelected: boolean;
  IsModifySelected: boolean;
  IsDeleteSelected: boolean;
  IsAllowSelected: boolean;
  IsCompleteSelected: boolean;
  IsOverrideSelected: boolean;
  IsEveryoneFiltersSelected: boolean;
  IsSelectSelected: boolean;
  IsWarnSelected: boolean;
}
